import { MenuComponent } from './components/MenuComponent';
import { DrawerComponent } from './components/_DrawerComponent';
import { ToggleComponent } from './components/_ToggleComponent';
import { ScrollComponent } from './components/_ScrollComponent';

const menuReinitialization = () => {
	setTimeout(() => {
		MenuComponent.reinitialization();
		DrawerComponent.reinitialization();
		ToggleComponent.reinitialization();
		ScrollComponent.reinitialization();
	}, 50);
};

export { menuReinitialization };
